const initialState = {
  bulkData: null,
  isLoading: false,
  processDate: null,
  statusUpdateData:null
};

const bulkDataUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPLOAD_DATA_SUCCESS':
      return { ...state, bulkData: action.payload, isLoading: false };
    case "FETCH_PROCESS_DATA":
      return {...state, processDate: action.payload,isLoading: false }  
    case "FETCH_UPLOADSTATUS_DATA":
      return {...state, statusUpdateData: action.payload,isLoading: false }  
    default:
      return state;
  }
};

export default bulkDataUploadReducer;